import { Link } from 'react-router-dom'
import { EmptyState } from '@/shared/components/EmptyState'
import { Tooltip } from '@/shared/components/Tooltip'
import type { ProviderUsedBy } from '@/lib/apiTypes'
import { formatDate } from '@/lib/format'

/** Live usage tab: state workspaces with this exact version pinned in .terraform.lock.hcl -
 *  the live blast radius, discovered from pushed lock files. Each workspace links to its
 *  State-page detail. */
export function VersionUsagePanel({ orgId, usedBy }: { orgId: string; usedBy: ProviderUsedBy[] }) {
  if (usedBy.length === 0) {
    return <EmptyState icon="⬡" title="Not locked by any workspace" subtitle="No pushed lock file currently pins this version." />
  }
  return (
    <div className="table-wrap table-scroll" style={{ maxHeight: 300 }}>
      <table>
        <thead>
          <tr>
            <th>
              <Tooltip text="State workspace whose pushed lock file pins this exact version." placement="top">
                <span tabIndex={0} className="cursor-help">Workspace</span>
              </Tooltip>
            </th>
            <th>
              <Tooltip text="When that workspace locked this version." placement="top">
                <span tabIndex={0} className="cursor-help">Locked</span>
              </Tooltip>
            </th>
          </tr>
        </thead>
        <tbody>
          {usedBy.map((u) => (
            <tr key={u.workspace_id}>
              <td style={{ fontSize: '0.82rem' }}>
                <Link to={`/org/${orgId}/state/${encodeURIComponent(u.workspace_name)}`}>
                  {u.workspace_name}
                </Link>
              </td>
              <td style={{ fontSize: '0.75rem', color: 'var(--text2)' }}>{formatDate(u.locked_at)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

